module.exports = __webpack_public_path__ + "47bc423d80b2c1f2425ce10f28229fe1.png";